import { useForm } from "react-hook-form";
import { toast } from 'react-toastify';
import React ,{useState} from "react";
import { useAddLearningOutcomeDetailMutation,useGetCourseListQuery,useGetLearningOutcomeListQuery} from "../../../Services/api";

export default function Create() {
    const notify = () => '';
    const { register, handleSubmit, formState: { errors }} = useForm();
    const [addLearningOutcome,isLoading] = useAddLearningOutcomeDetailMutation();

    const onSubmit = (values,e) => {
        const formData = new FormData();
        formData.append('lpid', values.lpid);
        formData.append('bullet_point', values.bullet_point);
        formData.append('file', values.file[0]);
        formData.append('study_hours', values.study_hours);
        formData.append('type', 'learning_outcome_details');
        // for (let i = 0; i < values.video_title.length; i++) {
        //     formData.append('video_title', values.video_title[i]);
        //     formData.append('old_name', values.old_name[i]);
        //     formData.append('video', values.video[i][0]);
        // }
        for (let i = 0; i < values.article_title.length; i++) {
            formData.append('article_title', values.article_title[i]);
            formData.append('article_link', values.article_link[i]);
        }
        for (let i = 0; i < values.case_study_title.length; i++) {
            formData.append('case_study_title', values.case_study_title[i]);
            formData.append('case_study_file', values.case_study_file[i][0]);
        }
       
        addLearningOutcome( formData)
        .unwrap()
        .then((payload) => {
            if (payload.status) {
                 e.target.reset()
                toast.success(payload.message)
            } else {
                toast.error(payload.message)
            }
        })
        .catch((error) => {
            toast.error(error.data.message)
        });
        notify();
    };
    const { 
        data: getCourseList        
    } = useGetCourseListQuery({  params:''});
    const [courseCode,setCourseCode] = useState(0);
    const findLession=(e)=>{
        setCourseCode(e.target.value);
    }
    const { 
        data: LearningOutcomeList        
    } = useGetLearningOutcomeListQuery({  params:courseCode});
    return (
        <div className="tab-pane fade" id="bordered-justified-profile" role="tabpanel" aria-labelledby="profile-tab" >
            <section className="section">
                <div className="card">
                    <div className="card-body">
                    <h5 className="card-title">Add Learning Outcome Detail</h5>
                        <form onSubmit={handleSubmit(onSubmit)} >
                            <div className="row mb-3">
                                <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Course</label>
                                <div className="col-sm-10">
                                <select  {...register("course_id", { required: true })} className="form-control" onChange={findLession}>
                                    <option value="">Select Course</option>                                           
                                    {                            
                                    getCourseList?.data?.map((item) => {
                                        return (
                                            <option key={item.course_id} value={item.course_id}>{item.course_name}</option>                                           
                                            )
                                        })
                                    }
                                    </select>
                                    {errors.course_id && <span  className="text-danger">Course is required</span>}
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Element</label>
                                <div className="col-sm-10">
                                <select  {...register("lpid", { required: true })} className="form-control">
                                    <option value="">Select Element</option>                                           
                                    {                            
                                    LearningOutcomeList?.data?.map((item) => {
                                        return (
                                            <option key={item.lpid} value={item.lpid}>{item.element_name}</option>                                           
                                            )
                                        })
                                    }
                                    </select>
                                    {errors.lpid && <span  className="text-danger">Course is required</span>}
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Bullet Point</label>
                                <div className="col-sm-10">
                                    <input type="name" {...register("bullet_point" ,{ required: true})} className="form-control" />
                                    {errors.bullet_point && <span  className="text-danger">Bullet Points is required</span>}
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">File Name</label>
                                <div className="col-sm-10">
                                    <input type="file" {...register('file' ,{ required: true })} className="form-control" />
                                    {errors.file && <span  className="text-danger">File Name is required</span>}

                                </div>
                            </div>
                            <div className="row mb-3">
                                <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Study Hours</label>
                                <div className="col-sm-10">
                                    <input type="number" {...register('study_hours' ,{ required: true })} className="form-control" />

                                    {errors.study_hours && <span  className="text-danger">Study Hours is required</span>}

                                </div>
                            </div>
                            {/* videos start */}
                            {/* <div className="row table-responsive"> */}
                                {/* <table className="table table-bordered"> */}
                                    {/* <thead>
                                        <tr>
                                            <th>Relevant Videos1 Title</th>
                                            <th>Old Videos Name</th>
                                            <th>Relevant Videos</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td style={{width:'40%'}}>
                                               <input type="text" {...register('video_title[0]')} className="form-control" />
                                            </td>
                                            <td style={{width:'40%'}}>
                                               <input type="text" {...register('old_name[0]')} className="form-control" />
                                            </td>
                                            <td style={{width:'20%'}}>
                                               <input type="file" {...register('video[0]')} className="form-control" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                               <input type="text" {...register('video_title[1]')} className="form-control" />
                                            </td>
                                            <td>
                                               <input type="text" {...register('old_name[1]')} className="form-control" />
                                            </td>
                                            <td>
                                               <input type="file" {...register('video[1]')} className="form-control" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                               <input type="text" {...register('video_title[2]')} className="form-control" />
                                            </td>
                                            <td>
                                               <input type="text" {...register('old_name[2]')} className="form-control" />
                                            </td>
                                            <td>
                                               <input type="file" {...register('video[2]')} className="form-control" />
                                            </td>
                                        </tr> */}
                                        {/* <tr>
                                            <td>
                                               <input type="text" {...register('video_title[3]')} className="form-control" />
                                            </td>
                                            <td>
                                               <input type="text" {...register('old_name[3]')} className="form-control" />
                                            </td>
                                            <td>
                                               <input type="file" {...register('video[3]')} className="form-control" />
                                            </td>
                                        </tr> */}
                                        {/* <tr>
                                            <td>
                                               <input type="text" {...register('video_title[4]')} className="form-control" />
                                            </td>
                                            <td>
                                               <input type="text" {...register('old_name[4]')} className="form-control" />
                                            </td>
                                            <td>
                                               <input type="file" {...register('video[4]')} className="form-control" />
                                            </td>
                                        </tr> */}
                                    {/* </tbody>
                                </table>
                            </div> */}
                            {/* videos end */}
                            {/* Article start */}
                            <div className="row table-responsive">
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>Article Title</th>
                                            <th>Article Link</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                               <input type="text" {...register('article_title[0]')} className="form-control" />
                                            </td>
                                            <td>
                                               <input type="text" {...register('article_link[0]')} className="form-control" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                               <input type="text" {...register('article_title[1]')} className="form-control" />
                                            </td>
                                            <td>
                                               <input type="text" {...register('article_link[1]')} className="form-control" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                               <input type="text" {...register('article_title[2]')} className="form-control" />
                                            </td>
                                            <td>
                                               <input type="text" {...register('article_link[2]')} className="form-control" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                               <input type="text" {...register('article_title[3]')} className="form-control" />
                                            </td>
                                            <td>
                                               <input type="text" {...register('article_link[3]')} className="form-control" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                               <input type="text" {...register('article_title[4]')} className="form-control" />
                                            </td>
                                            <td>
                                               <input type="text" {...register('article_link[4]')} className="form-control" />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            {/* Article end */}
                            {/* Case Study start */}
                            <div className="row table-responsive">
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>Case Study Title</th>
                                            <th>Case Study File</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                               <input type="text" {...register('case_study_title[0]')} className="form-control" />
                                            </td>
                                            <td>
                                               <input type="file" {...register('case_study_file[0]')} className="form-control" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                               <input type="text" {...register('case_study_title[1]')} className="form-control" />
                                            </td>
                                            <td>
                                               <input type="file" {...register('case_study_file[1]')} className="form-control" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                               <input type="text" {...register('case_study_title[2]')} className="form-control" />
                                            </td>
                                            <td>
                                               <input type="file" {...register('case_study_file[2]')} className="form-control" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                               <input type="text" {...register('case_study_title[3]')} className="form-control" />
                                            </td>
                                            <td>
                                               <input type="file" {...register('case_study_file[3]')} className="form-control" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                               <input type="text" {...register('case_study_title[4]')} className="form-control" />
                                            </td>
                                            <td>
                                               <input type="file" {...register('case_study_file[4]')} className="form-control" />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            {/* case_study end */}
                            <div className="row mb-3">
                                <label className="col-sm-2 col-form-label"></label>
                                <div className="col-sm-10">
                                     {isLoading.status !='pending' ? 
                                                
                                        <button type="submit" className="btn btn-warning w-100" >Add Outcome Details</button>
                                                :
                                        <button  className="btn btn-warning w-100" ><div className="spinner-border text-muted"></div></button>
                                    }
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </section>
        </div>
    );
}